import script from "./TheNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./TheNavbar.vue?vue&type=script&setup=true&lang=js"

import "./TheNavbar.vue?vue&type=style&index=0&id=a735f178&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a735f178"]])

export default __exports__